import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const Navbar = () => {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/members', label: 'Members' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
    { path: '/credits', label: 'Credits' },
    { path: '/art', label: 'Art' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="bg-gradient-to-r from-red-900 via-red-800 to-red-900 shadow-2xl border-b border-red-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0" onClick={closeMobileMenu}>
              <h1 className="text-2xl font-bold text-white hover:text-red-200 transition-colors duration-300">
                ISMP
              </h1>
            </Link>
            {/* Desktop Navigation */}
            <div className="hidden md:ml-8 md:flex md:space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 hover:bg-red-700 hover:text-white ${
                    location.pathname === item.path
                      ? 'bg-red-700 text-white shadow-lg'
                      : 'text-red-100 hover:text-white'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
          
          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            {isAuthenticated ? (
              <>
                <Link to="/admin">
                  <Button variant="outline" className="bg-red-700 border-red-600 text-white hover:bg-red-600 hover:border-red-500">
                    Admin Panel
                  </Button>
                </Link>
                <Button 
                  onClick={logout}
                  variant="outline" 
                  className="bg-red-800 border-red-700 text-white hover:bg-red-700 hover:border-red-600"
                >
                  Logout
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button variant="outline" className="bg-red-700 border-red-600 text-white hover:bg-red-600 hover:border-red-500">
                  Admin Login
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-red-100 hover:text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition-colors duration-200"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {!isMobileMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-red-900 border-t border-red-600">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMobileMenu}
              className={`block px-3 py-2 rounded-md text-base font-medium transition-all duration-300 hover:bg-red-700 hover:text-white ${
                location.pathname === item.path
                  ? 'bg-red-700 text-white shadow-lg'
                  : 'text-red-100 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
          
          {/* Mobile Auth Buttons */}
          <div className="pt-4 pb-3 border-t border-red-600">
            <div className="space-y-2">
              {isAuthenticated ? (
                <>
                  <Link to="/admin" onClick={closeMobileMenu} className="block">
                    <Button 
                      variant="outline" 
                      className="w-full bg-red-700 border-red-600 text-white hover:bg-red-600 hover:border-red-500"
                    >
                      Admin Panel
                    </Button>
                  </Link>
                  <Button 
                    onClick={() => {
                      logout();
                      closeMobileMenu();
                    }}
                    variant="outline" 
                    className="w-full bg-red-800 border-red-700 text-white hover:bg-red-700 hover:border-red-600"
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <Link to="/login" onClick={closeMobileMenu} className="block">
                  <Button 
                    variant="outline" 
                    className="w-full bg-red-700 border-red-600 text-white hover:bg-red-600 hover:border-red-500"
                  >
                    Admin Login
                  </Button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;